import Map from "can/map/";
import "can/map/define/";

export default Map.extend({
    copyright: "",
    mobileMode: false,
    hasProducts: false,
    mobileWorker: false,
    isUserRoleAdmin: false,
    isUserRoleVTAdmin: false,
    allowSubAccountBranding: false,
    isReseller: false,
    isNotDriver: true,
    permissions: [],
    hideFuelReceipts: true,
    hasHOSReports: true,
    hasIFTAReports: true,
    hasWorkOrderReports: true,
    hideLogShowEdits: false,
    userPemissions: [],
    products: {
        hosOnly: false,
        dvirOnly: false,
        hosAndDvir: false,
        mobileWorkerOnly: false,
        hosAndMobileWorker: false,
        dvirAndMobileWorker: false,
        hosDvirAndMobileWorker: false
    },
    menus: [],
});
